var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"angle"},[_c('div',{staticClass:"Canvas",attrs:{"id":'angle'+_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }